<template>
  <div class="intro mk-flex-column-start-center">
    <img class="intro-img" :src="topBg">
    <div class="intro-main">
      <div class="intro-main-fixed">
        <img @click="status = 'about'" class="intro-main-fixed_img" :src=" status === 'about' ? buttonLeftSel : buttonLeft " >
        <img @click="status = 'map'" :src=" status === 'map' ? buttonRightSel : buttonRight" >
      </div>
      <img class="intro-main-img" :src="status === 'about' ? mainBg : bottomBg">
    </div>
    <div class="layout"></div>
  </div>
</template>

<script>

export default {
  name: 'introduction',
  beforeCreate () {

  },
  components: {
  },
  data () {
    return {
      topBg: require('@/assets/img/intro-bg.png'),
      mainBg: require('@/assets/img/intro-main-bg.png'),
      bottomBg: require('@/assets/img/intro-bottom-bg.png'),
      buttonLeft: require('@/assets/img/about.png'),
      buttonLeftSel: require('@/assets/img/about-sel.png'),
      buttonRight: require('@/assets/img/map.png'),
      buttonRightSel: require('@/assets/img/map-sel.png'),
      status: 'about'
    }
  },
  methods: {
    change (status) {
      this.status = status
    }
  }
}
</script>
<style scoped>
  img {
    vertical-align: bottom;
  }
  .intro {
    width: 100%;
    background-color: #F9F9F9;
  }
  .intro-img {
    width: 100%;
    height: 388px;
  }
  .intro-main {
    width: 100%;
    height: 476px;
    position: relative;
    /* background: #ffffff; */
    /* margin-bottom: 35px; */
  }
  .intro-main-img {
    margin-top: 86px;
    width: 100%;
    height: 354px;
  }
  .intro-main-fixed {
    position: absolute;
    left: 0;
    top: -74px;
    width: 100%;
    height: 147px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .intro-main-fixed img {
    width: 304px;
    height: 147px;
  }
  .intro-main-fixed_img {
    margin-right: 44px;
  }
  .layout {
    height: 128px;
  }
</style>
